
export const categoryPrices = {
  Soap: '60',
  Facewash: '170',
  Shampoo: '150',
  Facepack: '170',
  Baby: '150',
  Others: '150',
};
export const soapProducts = [
  {
    img: './soap/avocado.png',
    title: 'Avocado Soap',
    subtitle: '(Deep Moisture)',
    description: 'Deeply hydrates dry skin, calms redness & nourishes skin.',
    tags: ['Soft Skin', 'Dry Skin']
  },
  {
    img: './soap/ashwagandha.png',
    title: 'Ashwagandha Soap',
    subtitle: '(Youth Boost)',
    description: 'Reduces dark spots & blemishes while keeping skin looking young.',
    tags: ['Young Skin', 'Glow']
  },
  {
    img: './soap/strawberry.png',
    title: 'Strawberry Soap',
    subtitle: '(Fruit Scrub)',
    description: 'Rich in Vitamin C to scrub away dead skin & reveal a bright glow.',
    tags: ['Glow', 'No Pimples']
  },
  {
    img: './soap/grape.png',
    title: 'Grape Soap',
    subtitle: '(Clear Tone)',
    description: 'A versatile soap that fights pimples & brightens skin tone.',
    tags: ['Clear Skin', 'No Pimples']
  },
  {
    img: './soap/papaya.png',
    title: 'Papaya Soap',
    subtitle: '(Spot Remover)',
    description: 'Removes dead skin cells to brighten face & reduce dark patches.',
    tags: ['Remove Dark Spots', 'Glow']
  },
  {
    img: './soap/orange.png',
    title: 'Orange Soap',
    subtitle: '(Vitamin C)',
    description: 'Rich in Vitamin C to fight dullness & tighten pores.',
    tags: ['Glow', 'Oil Control']
  },
  {
    img: './soap/pomegranate.png',
    title: 'Pomegranate Soap',
    subtitle: '(Skin Tightening)',
    description: 'Fights wrinkles & balances oil for firm, happy skin.',
    tags: ['Young Skin', 'Firm Skin']
  },
  {
    img: './soap/jamun.png',
    title: 'Jamun Soap',
    subtitle: '(Pimple Fighter)',
    description: 'Controls sticky oil & fights pimple-causing bacteria.',
    tags: ['No Pimples', 'Oil Control']
  },
  {
    img: './soap/cucumber.png',
    title: 'Cucumber Soap',
    subtitle: '(Cooling)',
    description: 'Cools down hot, irritated skin & fades dark spots.',
    tags: ['Cooling', 'Soft Skin']
  },
  {
    img: './soap/beetroot.png',
    title: 'Beetroot Soap',
    subtitle: '(Pink Glow)',
    description: 'Natural ingredients to brighten skin tone & smooth fine lines.',
    tags: ['Glow', 'Young Skin']
  },
  {
    img: './soap/potato.png',
    title: 'Potato Soap',
    subtitle: '(Tan Remover)',
    description: 'Brightens skin & cleans up dark patches from the sun.',
    tags: ['Remove Dark Spots', 'Remove Tan']
  },
  {
    img: './soap/turmeric.png',
    title: 'Turmeric Soap',
    subtitle: '(Glow)',
    description: 'Fights pimples, removes tan & gives a glow.',
    tags: ['Glow', 'Remove Tan']
  },
  {
    img: './soap/rose.png',
    title: 'Rose Soap',
    subtitle: '(Soft & Bright)',
    description: 'Hydrates & soothes skin for a fresh, rosy look.',
    tags: ['Soft Skin', 'Glow']
  },
  {
    img: './soap/tulsi.png',
    title: 'Tulsi Soap',
    subtitle: '(Skin Detox)',
    description: 'Cleans out dirt & oil to stop pimples before they start.',
    tags: ['No Pimples', 'Deep Clean']
  },
  {
    img: './soap/flaxseed.png',
    title: 'Flaxseed Soap',
    subtitle: '(Skin Food)',
    description: 'Feeds the skin with moisture to make it look plump & young.',
    tags: ['Young Skin', 'Soft Skin']
  },
  {
    img: "./soap/neem.png",
    title: "Neem Soap",
    subtitle: "(Germ Fighter)",
    description: "A powerful cleaner that fights pimples & stops itching.",
    tags: ["No Pimples", "Itch Relief"]
  },
  {
    img: './soap/saffron.png',
    title: 'Saffron Soap',
    subtitle: '(Luxury Glow)',
    description: 'Brightens skin color & reduces dark marks.',
    tags: ['Glow', 'Remove Dark Spots']
  },
  {
    img: './soap/multani.png',
    title: 'Multani Mitti Soap',
    subtitle: '(Oil Absorber)',
    description: 'Soaks up extra oil like a sponge & clears pimple marks.',
    tags: ['Oil Control', 'Clear Skin']
  },
  {
    img: './soap/liquorice.png',
    title: 'Licorice Soap',
    subtitle: '(Skin White & Pigmentation)',
    description: 'Protects skin from sun damage & keeps it looking fresh.',
    tags: ['Sun Protect', 'Glow']
  },
  {
    img: './soap/nalugumaavu.png',
    title: 'Nalugu Maavu Soap',
    subtitle: '(Herbal Bath)',
    description: 'Gently cleanses to remove tan & give a glow.',
    tags: ['Remove Tan', 'Glow']
  },
  {
    img: './soap/manjistha.png',
    title: 'Manjistha Soap',
    subtitle: '(Clear Skin)',
    description: 'Heals skin problems & reduces dark patches.',
    tags: ['Clear Skin', 'Remove Dark Spots']
  },
  {
    img: './soap/kaolinclay.png',
    title: 'Kaolin Clay Soap',
    subtitle: '(Gentle Wash)',
    description: 'A very gentle wash perfect for sensitive or dry skin.',
    tags: ['Sensitive Skin', 'Soft Skin']
  },
  {
    img: './soap/frenchclay.png',
    title: 'French Clay Soap',
    subtitle: '(Pore Cleaner)',
    description: 'Pulls out dirt & toxins from deep inside pores.',
    tags: ['Deep Clean', 'Oil Control']
  },
  {
    img: './soap/redclay.png',
    title: 'Red Clay Soap',
    subtitle: '(Firming)',
    description: 'Cleans deep & tightens skin to make it look strong.',
    tags: ['Young Skin', 'Deep Clean']
  },
  {
    img: './soap/pinkclay.png',
    title: 'Pink Clay Soap',
    subtitle: '(Balancing)',
    description: 'Gently cleans & brightens for smooth, happy skin.',
    tags: ['Glow', 'Soft Skin']
  },
  {
    img: './soap/carrot.png',
    title: 'Carrot Soap',
    subtitle: '(Brightening)',
    description: 'Rich in vitamins to protect skin from harsh sunlight.',
    tags: ['Sun Protect', 'Glow']
  },
];

export const babyProducts = [
  {
    id: 1,
    title: "Baby Talcum Powder",
    subtitle: "(Safe & Dry)",
    description: "Keeps baby dry without any harsh chemicals.",
    img: "./baby/powder.png",
    tags: ["Safe for Baby", "Dry Skin"]
  },
  {
    id: 2,
    title: "Nalugu Maavu Powder",
    subtitle: "(Above 5 Months Only)",
    description: "A traditional herbal bath that is super gentle on baby skin.",
    img: "./baby/babynalugu.png",
    tags: ["Safe for Baby", "Natural"]
  },
  {
    id: 3,
    title: "Baby Soap",
    subtitle: "(Tears Free)",
    description: "Gentle & natural cleansing for your baby's delicate skin.",
    img: "./baby/babysoap.png",
    tags: ["Sleep Well", "Soft Skin"]
  },
  {
    id: 4,
    title: "Baby Kajal",
    subtitle: "(Cool Eyes)",
    description: "Made with almond oil to cool & protect little eyes.",
    img: "./baby/kajal.png",
    tags: ["Eye Care", "Cooling"]
  }
];

export const otherProducts = [
  {
    img: './others/lipbalm.jpeg',
    title: 'Lip Balm',
    subtitle: '(Pink Tint)',
    description: 'Heals dry lips & gives a cute pink color.',
    tags: ['Lip Care', 'Soft Lips']
  },
  {
    img: './others/aloeveragel.png',
    title: 'Aloe Vera Gel',
    subtitle: '(Cooling Gel)',
    description: 'Cools down burns & hydrates hair & skin.',
    tags: ['Cooling', 'Soft Skin']
  },
  {
    img: './others/potato.png',
    title: 'Potato Face Cream',
    subtitle: '(Spot Eraser)',
    description: 'Moisturizes face & erases dark spots.',
    tags: ['Remove Dark Spots', 'Soft Skin']
  },
  {
    img: './others/moisturizer.jpeg',
    title: 'Daily Moisturizer',
    subtitle: '(All Day Soft)',
    description: 'Keeps skin soft all day without feeling sticky.',
    tags: ['Soft Skin', 'Daily Use']
  },
  {
    img: './others/anti-acne.png', 
    title: 'Anti-Acne Oil Serum',
    subtitle: '(Clear Skin)',
    description: 'Helps to remove redspots & give smoothness.',
    tags: ['no-spots', 'smooth-skin', 'clean-face'],
    howToUse: 'For ages 17+: Use at night. Apply with a cotton pad.'
  },
  {
    img: './others/dry-skin.png', 
    title: 'Dry Skin Oil Serum',
    subtitle: '(Deep Hydration)',
    description: 'Makes your face soft & not scratchy.',
    tags: ['soft-skin', 'no-dry-patches', 'happy-face'],
    howToUse: 'For ages 17+: Use at night. Apply with a cotton pad.'
  },
  {
    img: './others/brightening.png', 
    title: 'Brightening Oil Serum',
    subtitle: '(Radiant Glow)',
    description: 'Makes your face bright.',
    tags: ['bright-face', 'sunny-look', 'awake-skin'],
    howToUse: 'For ages 17+: Use at night. Apply with a cotton pad.'
  },
  {
    img: './others/glow.png', 
    title: 'Glow Face Serum',
    subtitle: '(Instant Shine)',
    description: 'Makes your cheeks shine nicely like a little star.',
    tags: ['shiny-skin', 'super-glow', 'healthy-look'],
    howToUse: 'For ages 17+: Use at night. Apply with a cotton pad.'
  },
  {
    img: './others/coffee.png', 
    title: 'Coffee Scrub',
    subtitle: '(Fresh Skin)',
    description: 'Scrub away dead skin & make your face fresh.',
    tags: ['scrubbing', 'fresh-skin', 'coffee'],
  },
  {
    img: './others/cinnamon-coffee.png', 
    title: 'Cinnamon & Coffee Scrub',
    subtitle: '(Deep Clean)',
    description: 'Cleans deep & helps blood flow.',
    tags: ['warming', 'deep-clean', 'blood-flow']
  },
  {
    img: './others/moisturizing.png', 
    title: 'Moisturizing Scrub',
    subtitle: '(Gentle Polish)',
    description: 'Gently cleans your skin & stays soft.',
    tags: ['gentle', 'soft-skin', 'hydrating']
  },
  {
    img: './others/foot.png', 
    title: 'Foot Scrub',
    subtitle: '(Smooth Heels)',
    description: 'A strong scrub used only for feet to smooth out rough heels.',
    tags: ['rough-skin', 'smooth-heels', 'feet-only']
  },
  {
    img: './others/sandalwood.png', 
    title: 'Sandalwood Face Gel',
    subtitle: '(Cooling Effect)',
    description: 'Cools the skin down & helps reducing redness or irritation.',
    tags: ['cooling', 'soothing', 'redness']
  },
  {
    img: './others/mulethi.png', 
    title: 'Mulethi Gel',
    subtitle: '(Spot Remover)',
    description: 'Helps fade dark marks & brightens the skin tone naturally.',
    tags: ['dark-marks', 'brightening', 'uneven-skin']
  },
  {
    img: './others/rose.png', 
    title: 'Rose Face Gel',
    subtitle: '(Pore Tightening)',
    description: 'Adds light moisture to the skin & helps tighten pores.',
    tags: ['hydrating', 'pores', 'refreshing']
  },
  {
    img: './others/papaya.png', 
    title: 'Papaya Face Gel',
    subtitle: '(Tan Remover)',
    description: 'Softens the skin & helps clear up dark patches.',
    tags: ['softening', 'dark-patches', 'clear-skin']
  },
  {
    img: './others/glow-gel.png', 
    title: 'Glow Gel',
    subtitle: '(Daily Shine)',
    description: 'Make the skin look healthy & shiny.',
    tags: ['healthy-look', 'shiny', 'hydrating']
  }
];

export const faceWashProducts = [
  {
    img: './facewash/multani-mitti.png', 
    title: <>Powder Facewash <br/> <span className="skin-type-highlight">For Oily Skin</span></>,
    description: 'Deep cleansing with Multani Mitti & Neem.',
    tags: 'Oily Skin',
  },
  {
    img: './facewash/oats.png', 
    title: <>Powder Facewash <br/> <span className="skin-type-highlight">For Dry Skin</span></>,
    description: 'Gentle hydration with Oats & Honey.',
    tags: 'Dry Skin',
  },
  {
    img: './facewash/rose-petals.png', 
    title: <>Powder Facewash <br/> <span className="skin-type-highlight">For Combination Skin</span></>,
    description: 'Balancing care with Rose Petals.',
    tags: 'Combination',
  },
  {
    img: './facewash/cucumber.png', 
    title: <>Powder Facewash <br/> <span className="skin-type-highlight">For Sensitive Skin</span></>,
    description: 'Soothing relief with Cucumber & Aloe.',
    tags: 'Sensitive',
  }
];


export const shampooProducts = [
  {
    img: './shampoo/fenugreek.jpg', // Ensure you have this image
    title: 'Fenugreek & Soapnut Shampoo',
    subtitle: '(Hair Fall & Dandruff)',
    description: 'Chemical free formula that reduces hair fall, dandruff & promotes hair growth & shine.',
    tags: ['Hair Fall', 'Dandruff']
  },
  {
    img: './shampoo/hibiscus.jpg', // Ensure you have this image
    title: 'Hibiscus & Soapnut Shampoo',
    subtitle: '(Condition & Strength)',
    description: 'Cleanses, conditions & strengthens hair, promoting growth & shine.',
    tags: ['Conditioning', 'Strengthening']
  },
  {
    img: './shampoo/rosemary.jpeg', // Ensure you have this image
    title: 'Rosemary & Soapnut Shampoo',
    subtitle: '(Scalp Care)',
    description: 'Improves blood flow, feeds your scalp & encourages hair growth.',
    tags: ['Scalp Care', 'Hair Growth', 'Circulation']
  },
  {
    img: './shampoo/flaxseed.jpeg', // Ensure you have this image
    title: 'Flaxseed & Soapnut Shampoo',
    subtitle: '(Moisture & Shine)',
    description: 'Moisturises, promotes hair growth & shine.',
    tags: ['Moisturizing', 'Hair Growth']
  }
];

export const faceMaskProducts = [
  {
    img: './facemask/koreanglow.png',
    title: 'Korean Pack',
    subtitle: '(Glass Shine)',
    description: 'Makes skin super shiny like glass.',
    tags: ['Glow', 'Shiny Skin']
  },
  {
    img: './facemask/pigmentation.png',
    title: 'Anti-Pigmentation Pack',
    subtitle: '(Even Tone)',
    description: 'Removes dark patches for even color.',
    tags: ['Remove Dark Spots', 'Clear Skin']
  },
  {
    img: './facemask/instantglow.png',
    title: 'Instant Glow Pack',
    subtitle: '(Party Look)',
    description: 'Wake up tired skin instantly for a party.',
    tags: ['Glow', 'Bright Skin']
  }
];